import { render, staticRenderFns } from "./BrunetteEntering.vue?vue&type=template&id=176a39e6&"
import script from "./BrunetteEntering.vue?vue&type=script&lang=ts&"
export * from "./BrunetteEntering.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports